<div class="row my-3 ml-3 w-100">
  <button class="q-btn q-main q-btn-save-custom" (click)="GenerateBilan()" [disabled]="SaveBilanLoaded"><i [ngClass]="[SaveBilanLoaded ? 'fas fa-spin fa-spinner fa-pulse' : 'fas fa-save']" class="mr-2"></i>Générer les bilans</button>
</div>


<div class="q-date-creation my-3 ml-3">
  <label class="q-bo-label"> Date :</label>
  <q-date [(ngValue)]="DateCreation" [required]="true"></q-date>
</div>

<div class="my-3 ml-3">
  <label class="q-bo-label"> Commentaires :</label>
  <textarea [(ngModel)]="CommentCreation" class="d-block w-100 q-textarea-comment p-1"></textarea>
</div>


<!--Liste des objectifs pédagogiques-->
<div #objpedaListContainer class="pt-3">
  <div *ngIf="ObjectifList && ObjectifList.length > 0 && !ObjectifLoaded" class="my-3 ml-3">
    <div *ngFor="let objpeda of ObjectifList">
      <div class="q-bloc-objpeda">
        <div class="row pr-0 q-pointer m-0 q-text-l q-accordion-objpeda" (click)="expendList($event)">
          <div class="d-flex align-items-center mx-3">
            <strong class="q-c-main">Objectif : {{objpeda.Title}}</strong>
          </div>
          <i class="fas fa-chevron-down chevron ml-auto m-2"></i>
        </div>
        <div>
          <table class="table table-striped table-condensed q-table-learnerOP" *ngIf="objpeda.LearnerList && objpeda.LearnerList.length > 0 && objpeda.ReachedList && objpeda.ReachedList.length > 0">
            <thead>
              <tr>
                <th scope="col">{{ 'learner' | trad }}</th>

                <th scope="col" *ngFor="let reached of objpeda.ReachedList">
                  <input type="radio" value="{{reached.Value}}" [checked]="GetAllObjectifState(objpeda.LearnerList, reached.Value)" (click)="SetAllObjectifState(objpeda.LearnerList, reached.Value);">&nbsp;{{reached.Text}}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let learner of objpeda.LearnerList;">
                <th scope="row">
                  <p class="mb-0">
                    <span>{{learner.LastName}} {{learner.FirstName}}</span>
                  </p>
                </th>

                <td *ngFor="let reached of objpeda.ReachedList">
                  <input type="radio" value="{{reached.Value}}" [checked]="learner.ObjectifState == reached.Value" (click)="UpdateObjectifState(learner, reached.Value)" />
                </td>

              </tr>
            </tbody>
          </table>
          <div *ngIf="!objpeda.LearnerList || objpeda.LearnerList.length == 0">
            <h5>Aucun apprenant sur le stage</h5>
          </div>
          <div *ngIf="!objpeda.ReachedList || objpeda.ReachedList.length == 0">
            <h5>Aucune atteinte sur le stage</h5>
          </div>
        </div>
      </div>
      <br />
    </div>
  </div>

  <div *ngIf="(!ObjectifList || ObjectifList.length == 0) && !ObjectifLoaded" class="my-3 ml-3">
    <h5>Aucun objectif pédagogique sur le stage</h5>
  </div>

  <div *ngIf="ObjectifLoaded"><i class="fas fa-spin fa-spinner q-c-main"></i> Chargement des objectifs pédagogiques</div>
</div>

